<div class="content-grid mdl-grid content-height" *ngIf="items" [style.background-color]="bgColor">
    <div class="mdl-layout-spacer"></div>
    <div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-phone mdl-cell--12-col-tablet content-centered">
        <h2 class="h2_B">{{title}}</h2>
        <div class="content-grid mdl-grid content-centered">
            <div *ngFor="let el of items" class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone mdl-cell--12-col-tablet card-width" [ngClass]="{'card-width__margin':items.length !== 1}">
                <div class="product-principal" (click)="openProduct(el)">
                    <div class="product-principal__images" [style.background-image]="'url('+el.main+')'">
                        <price-promotion class="product-principal__discount" *ngIf="el?.bestPricePromotion?.promotionType === 'RETAIL'" [promotion]="el?.bestPricePromotion" [typeText]="true"></price-promotion>
                    </div>
                    <div class="product-principal__info">
                        <div class="product-principal__info-title">
                            <a [routerLink]="transformUrl(el)" (click)="analytics.eCommerce_productClick(el)">
                                {{el.name}}
                            </a>
                        </div>
                        <div class="product-principal__info-details">
                            <div class="product-principal__info-details__icons">
                                <!-- <div *ngIf="el?.bestRoute?.numStops" class="info-icon"><i class="material-icons">location_on</i><span class="info-icon__text">{{'STOPS' | translate}}: </span><span class="info-icon__text-margin">{{el?.bestRoute?.numStops}}</span></div> -->
                                <!-- <div *ngIf="el?.bestRoute?.numLanguages && el?.bestRoute?.numLanguages != 1" class="info-icon"><i class="material-icons">public</i><span class="info-icon__text">{{'LANGUAGES' | translate}}: </span><span class="info-icon__text-margin">{{el?.bestRoute?.numLanguages}}</span></div> -->
                            </div>
                            <div class="product-principal__info-details__price">
                                <span class="from">{{'FROM' | translate}}</span>
                                <span class="price">{{el?.from | currency:currencyService.currencyStr:true:'1.2-2'}}</span>
                                <div class="price-box">
                                    <span *ngIf="el?.highPrice" class="price-box__old">{{el?.highPrice | currency:currencyService.currencyStr:true:'1.2-2'}}</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="product-principal__info-btn">
                            <button *ngIf="!isNode" class="" mat-raised-button color="primary">{{'MORE_DETAILS' | translate}}</button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="content-centered">
            <a class="load-more-button" *ngIf="pageable" (click)="loadMoreWasClicked()">{{'LOAD_MORE' | translate}}</a>
        </div>
    </div>
    <div class="mdl-layout-spacer"></div>
</div>